module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4D37x"))).then(() => module.bundle.root('fThBo'));